import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogContent,
  ModalDialogFooter,
  ModalDialogHeader,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import { AgreementRenderer } from '@/features/account/components/AgreementRenderer'
import { Checkbox } from '@/components/inputs/Checkbox'
import { FormField } from '@/components/Form'
import {
  SelectionLabel,
  SelectionLabelControl,
  SelectionLabelText,
} from '@/components/inputs/SelectionLabel'

export interface TermsOfUseAcceptanceDialogProps {
  isOpen: boolean
  isLoading: boolean
  termsMarkup: string
  agreed: boolean
  onAgreeChange: (agreed: boolean) => void
  onAccept: () => void
  onDecline: () => void
  isAcceptPending: boolean
  testId?: string
  contentTestId?: string
  agreeCheckboxTestId?: string
  acceptButtonTestId?: string
  closeButtonTestId?: string
}

/**
 * Terms of Use acceptance dialog presentation component
 */
export function TermsOfUseAcceptanceDialog({
  isOpen,
  isLoading,
  termsMarkup,
  agreed,
  onAgreeChange,
  onAccept,
  onDecline,
  isAcceptPending,
  testId,
  contentTestId,
  agreeCheckboxTestId,
  acceptButtonTestId,
  closeButtonTestId,
}: TermsOfUseAcceptanceDialogProps) {
  return (
    <ModalDialog
      size="lg"
      isOpen={isOpen}
      onClose={onDecline}
      aria-label="Terms of Use"
      testId={testId}
    >
      <ModalDialogHeader />
      <ModalDialogContent testId={!isLoading ? contentTestId : undefined}>
        <AgreementRenderer isSkeleton={isLoading} markup={termsMarkup} />
      </ModalDialogContent>
      <ModalDialogFooter>
        <div className="pb-2xl px-base">
          <FormField>
            <SelectionLabel>
              <SelectionLabelControl>
                <Checkbox
                  checked={agreed}
                  onChange={onAgreeChange}
                  testId={agreeCheckboxTestId}
                  isSkeleton={isLoading}
                />
              </SelectionLabelControl>
              <SelectionLabelText isSkeleton={isLoading}>
                I have read and agree to the terms and conditions.
              </SelectionLabelText>
            </SelectionLabel>
          </FormField>
        </div>
        <ModalDialogActions>
          <Button
            label="Accept"
            onPress={onAccept}
            isDisabled={isLoading || !agreed}
            isPending={isAcceptPending}
            testId={acceptButtonTestId}
          />
          <Button
            label="Close"
            variant="outline"
            onPress={onDecline}
            isDisabled={isAcceptPending || isLoading}
            testId={closeButtonTestId}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
